// eslint-disable-next-line import/no-extraneous-dependencies
import flatpickr from 'flatpickr';

flatpickr('[data-reserve-date]', {
  altInput: false,
  altFormat: 'M d',
  dateFormat: 'Y-m-d',
  minDate: 'today',
  errorHandler: () => {},
  disableMobile: 'true',
  defaultDate: 'today',
});

const reserveForm = document.querySelector('[data-reserve-table]');
const restaurantId = document.querySelector('[data-reserve-restaurant-id]')?.dataset?.reserveRestaurantId;

const buildReservationURL = (partySize, date, time) => `https://www.opentable.com/restref/client/?restref=${restaurantId}&partySize=${partySize}&dateTime=${date}T${time}`;

const handleReservation = (event) => {
  event.preventDefault();

  const partySize = reserveForm.querySelector('[data-reserve-guests]').value;
  const date = reserveForm.querySelector('[data-reserve-date]').value;
  const time = reserveForm.querySelector('[data-reserve-time]').value;

  if (partySize && date && time) {
    const url = buildReservationURL(partySize, date, time);
    window.open(url, '_blank');
  }
};

reserveForm?.addEventListener('submit', handleReservation);
